<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{
        $t('text.reports') | firstLetterCapitalize
      }}</span>
    </div>
    <div class="page-card-content pt-20">
      <div class="page-content max-w-742">
        <div class="mb-10 dark-font">1. {{ $t('text.select_date_range') }}</div>
        <el-date-picker
          class="mb-20"
          v-model="date"
          type="datetimerange"
          format="dd/MM/yy h:mm:ss A"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="to"
          :start-placeholder="$t('text.start_time')"
          :end-placeholder="$t('text.end_time')"
          :unlink-panels="true"
          size="small"
        >
        </el-date-picker>
        <div class="mb-10 dark-font">
          2.
          {{
            $t('text.select_patients', {
              patients: $firstLetterCapitalize($store.state.locale.patients)
            })
          }}
        </div>
        <div class="group-wrapper" v-loading="loading">
          <el-tree
            ref="tree"
            :data="data"
            show-checkbox
            node-key="id"
            :props="defaultProps"
            default-expand-all
          >
          </el-tree>
        </div>
        <el-button
          class="common-btn"
          :loading="savingLoading"
          @click="download()"
          >{{ $t('text.export_report') }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import moment from 'moment'
export default {
  data() {
    return {
      loading: false,
      activeName: 'capacitance_readings',
      date: [
        moment().format('YYYY-MM-DD 00:00:00'),
        moment()
          .add(1, 'days')
          .format('YYYY-MM-DD 00:00:00')
      ],
      savingLoading: false,
      data: [
        {
          id: 0,
          label: this.$store.getters[`user/selecteOrganisationName`],
          children: []
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  mounted: function() {
    this.getPatients()
  },
  methods: {
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1
    },
    getPatients() {
      this.loading = true
      ApiService.GetOrganisationPatients(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          if (response.data.success) {
            this.loading = false
            this.data[0].children = response.data.data.map(building => {
              return {
                ...building,
                label: building.BuildingName,
                id: building.BuildingId,
                children: building.Floors.map(floor => {
                  return {
                    ...floor,
                    label: floor.FloorName,
                    id: floor.FloorId,
                    children: floor.Rooms.map(room => {
                      return {
                        ...room,
                        label: room.RoomNumber,
                        id: room.RoomId,
                        children: room.Patients.map(patient => {
                          return {
                            ...patient,
                            label: patient.Alias,
                            id: patient.PatientId
                          }
                        })
                      }
                    })
                  }
                })
              }
            })
          } else {
            this.loading = false
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    download() {
      // only patients ids
      let selectedData = this.$refs.tree
        .getCheckedNodes()
        .filter(item => !item.children)
        .map(item => item.id)
      if (!this.date.length || !selectedData.length) {
        let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
        this.$confirm(
          `<div class="warning-content">${this.$t(
            'text.please_complete_form'
          )}</div> <img class='warning-icon' src=${warningIconUrl}>`,
          this.$t('text.warning'),
          {
            confirmButtonText: this.$t('text.ok').toUpperCase(),
            confirmButtonClass: 'confirm-btn',
            type: 'warning',
            customClass: 'delete-warning-box',
            showClose: true,
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true,
            showCancelButton: false
          }
        )
        return false
      }
      this.savingLoading = true
      ApiService.DownloadReport(
        this.$store.getters[`user/selecteOrganisationId`],
        this.date[0],
        this.date[1],
        selectedData
      )
        .then(response => {
          this.savingLoading = false
          if (response.data.Success) {
            swal({
              icon: 'success',
              title: this.$t('text.export_in_progress'),
              text: this.$t('text.export_report_success_text')
            })
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.FailureInformation
            })
          }
        })
        .catch(() => {
          this.savingLoading = false
          swal({
            icon: 'error',
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
